<template>
  <div class="leftMenu">
    <TreeMenu
      ref="TreeMenu"
      :menuData="MenuList"
      :fieldMap="fieldMap"
      @select="select"
      :active="activeIndex"
    ></TreeMenu>
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
import TreeMenu from '@/components/TreeMenu/TreeMenu.vue'
export default {
  data() {
    return {
      activeIndex: '',
      MenuList: [],
      loading: false,
      fieldMap: {
        id: 'Id',
        title: 'AssetCategory',
        children: 'children',
      },
    }
  },
  props: {},
  components: { TreeMenu },
  methods: {
    ...mapMutations([
      'setAssetTreeSeacrh', // 将 `this.setdevTreeSearch()` 映射为 `this.$store.commit('increment')`
    ]),
    select(index) {
      window.sessionStorage.setItem('AssetTreeSeacrh', index)
      this.setAssetTreeSeacrh(index)
    },
    getMenuList() {
      this.loading = true
      this.$http
        .post('/AM/AM_AssetCategory/GetDataList', {})
        .then((resJson) => {
          this.loading = false
          if (resJson.Success) {
            this.MenuList = resJson.Data || []
            this.MenuList.unshift({
              AssetCategory: '全部',
              Id: '',
            })

            this.activeIndex =
              window.sessionStorage.getItem('AssetTreeSeacrh') || ''
          } else {
            this.$notify.error(resJson.Msg)
          }
        })
    },
    MenuSelect() {},
  },
  mounted() {},
  created() {
    this.getMenuList()
  },
  computed: {},
  watch: {},
}
</script>
<style lang="scss" scoped>
.leftMenu {
  width: 220px;
  height: 100%;
  overflow-y: auto;
}
</style>
